import { observer } from 'mobx-react';
import React, { useEffect, useState, useRef } from 'react';
import { DeepAnalysisReviewResultsRow } from './DeepAnalysisReviewResultModal.styles';
import { errorNotification } from '../../../layout/components/Notifications/notifications';
import { ReviewAssetTableRow } from './ReviewAssetTableRow';

export const DeepAnalysisResultsRow = observer((props) => {

  const {
    item,
    itemIndex,
    isEdited,
    onEditedIndexChange,
    relevantClasses,
    isNew,
    onClickDelete,
    scrollToMe,
    showSkeleton,
    isInBulkEditMode,
    isItemForBulkEdit,
    onBulkEditChange,
    handleFieldChange,
    addNewItem,
    showMissingFieldsError,
    disabled
  } = props;

  const [currentItem, setCurrentItem] = useState({});
  const [defaultValues, setDefaultValues] = useState({});
  const [isHoverOn, setIsHoverOn] = useState(false);
  const rowRef = useRef(null);

  useEffect(() => {
    if (!isNew) {
      setDefaultValues(item);
      setCurrentItem(item);
    }
  }, [item, isNew])

  useEffect(() => {
    if (scrollToMe && rowRef.current && showMissingFieldsError) {
      rowRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [scrollToMe, rowRef, showMissingFieldsError])

  const handleFundNameChange = (value) => updateChanges({ fund_name: value })


  const handleBlur = () => {
    if (isEdited) {
      const changes = {};
      Object.entries(currentItem).forEach(([key, value]) => {
        if (value !== defaultValues[key]) {
          changes[key] = value;
        }
      });

      if (Object.keys(changes).length > 0 && !isNew) {
        updateChanges(changes);
      }
    }

    if (isNew && !isHoverOn) {
      onEditedIndexChange?.(null);
    }
  };

  const updateChanges = (changes) => {
    handleFieldChange(changes);
    onEditedIndexChange?.(null);
  }

  const handleItemCategoryChange = (_clsId, catId) => {
    if (isNew) {
      setCurrentItem({ ...currentItem, categoryId: catId });
    } else {
      updateChanges({ categoryId: catId });
    }
  };

  const handleAddNewItem = () => {
    if (currentItem?.categoryId && currentItem?.item_name && currentItem?.amount) {
      if (!currentItem?.currency) {
        currentItem.currency = 'USD';
      }

      addNewItem(currentItem, "items");
      onEditedIndexChange?.(null);
      setCurrentItem({});
    }
    else {
      errorNotification('Please fill all fields');
    }
  }

  const onEditItem = (field, value) => {
    setCurrentItem({ ...currentItem, [field]: value });
    if (!isNew && ('currency' === field)) {
      updateChanges({ [field]: value });
    }
  }

  return (
    <DeepAnalysisReviewResultsRow
      ref={rowRef}
      isEdited={isEdited}
      onMouseEnter={() => { setIsHoverOn(true) }}
      onMouseLeave={() => { setIsHoverOn(false) }}
      onClick={() => { if (!isEdited) { onEditedIndexChange?.(itemIndex) } }}
      onBlur={handleBlur}
      isLoading={showSkeleton}
      isNew={isNew}
      disabled={disabled}
    >
      <ReviewAssetTableRow
        currentItem={currentItem}
        itemIndex={itemIndex}
        showMissingFieldsError={showMissingFieldsError}
        handleFundNameChange={handleFundNameChange}
        handleFieldChange={onEditItem}
        isHoverOn={isHoverOn}
        handleItemCategoryChange={handleItemCategoryChange}
        handleAddNewItem={handleAddNewItem}
        isEdited={isEdited}
        relevantClasses={relevantClasses}
        isNew={isNew}
        onClickDelete={onClickDelete}
        showSkeleton={showSkeleton}
        isInBulkEditMode={isInBulkEditMode}
        isItemForBulkEdit={isItemForBulkEdit}
        onBulkEditChange={onBulkEditChange}
      />
    </DeepAnalysisReviewResultsRow>
  )
})